
import store from '@/store/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

export default {
  /** Returns date string in format YYYY-MM-DD */
  dateToString (date) {
    if (!date || !date.constructor || !date.constructor.name || date.constructor.name != 'Date'
                                                             || !date.getTime())
      return '-'
    else
      return          date.getFullYear() + '-'
            + ('0' + (date.getMonth()+1)).slice(-2) + '-'
            + ('0' + (date.getDate())).slice(-2) 
  },
  
  calcTotal (invoice) {
    return (100*this.calcPayoutsTotal(invoice) + 100*this.calcChargesTotal(invoice) + 100*this.calcTaxesTotal(invoice))/100
  },
  calcPayoutsTotal (invoice) {
    let total = 0
    invoice.payouts.forEach(p => total += p.amount)
    console.log('total payouts = ', total)
    return total
  },
  calcChargesTotal (invoice) {
    if (!invoice || !invoice.charges) return 0
    let total = 0
    invoice.charges.forEach(c => total += c.amount)
    console.log('total charges = ', total)
    return total
  },
  calcTaxesTotal (invoice) {
    if (!invoice || !invoice.charges || !(invoice.charges.length > 0)) return 0
    let total = 0
    invoice.charges.forEach(c => {
      if (c.applicableTaxes && c.applicableTaxes.length) {
        c.applicableTaxes.forEach(t => total += (Math.round(100*t.rate*c.amount)) )
      }
    })
    console.log('total applicableTaxes = ', total/100)
    return total/100
  },
  displayAmount (amount) {
    const integers = (''+amount).split('.')[0] || '0'
    const decimals = (''+amount).split('.')[1]
    if (decimals) {
      return (store.getters.currency || '') + amount.toFixed(2)
    }
    else {
      return (store.getters.currency || '') + integers
    }
  },
}

export const progress = {
  start () {
    NProgress.start()
    return true
    // document.querySelectorAll('*').forEach(e => e.style.cursor = 'progress')
  },
  set (n) {
    NProgress.set(n)
  },
  inc (n) {
    NProgress.inc(n)
  },
  done () {
    if (typeof working == 'boolean') working = false
    NProgress.done()
    return true
    // document.querySelectorAll('*').forEach(e => e.style.cursor = 'auto')
  }
}